import axios from "axios";
import { DOWNLOAD_TASK_ATTACH } from "../store/config";

export const downloadAttach = (id: number, task_id: number, name: string) => {
  const token = localStorage.getItem("userToken");
  axios
    .get(DOWNLOAD_TASK_ATTACH(id, task_id), {
      headers: {
        Accept: "application/json",
        Authorization: "Bearer " + token,
      },
      responseType: "blob",
    })
    .then((response) => {
      // create file link in browser's memory
      const mimeType = response.headers["content-type"];

      const blob = new Blob([response.data], { type: mimeType });

      const isPDF = mimeType === "application/pdf";
      const isIOS = /iPhone|iPad|iPod/i.test(navigator.userAgent);

      const blobUrl = URL.createObjectURL(blob);

      if (isIOS && isPDF) {
        // On iOS, open PDFs in a new tab
		
        window.open(blobUrl, "_blank");
      } else {
        const link = document.createElement("a");
        link.href = blobUrl;

        if (isPDF) {
          // Let user view PDF in browser on desktop
          link.target = "_blank";
        } else {
          // Set filename for download
          console.log(name);
          link.setAttribute("download", name);
        }

        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }

      // Clean up
      URL.revokeObjectURL(blobUrl);
    });
};
